import React, { useState } from "react";
import classNames from "classnames";

interface RatingProps {
  value: number;                    // current rating value
  max?: number;                     // number of stars (default 5)
  readOnly?: boolean;               // if true => display only
  onChange?: (newValue: number) => void; // called when user selects a star
  className?: string;               // extra classes for wrapper
}

const Ratings: React.FC<RatingProps> = ({
  value,
  max = 5,
  readOnly = true,
  onChange,
  className,
}) => {
  const [hovered, setHovered] = useState<number | null>(null);

  // which value to show (hover preview if not readOnly)
  const displayValue = hovered ?? value;

  const stars = Array.from({ length: max }, (_, i) => i + 1).map((item) => (
    <span key={item}>
      <i
        className={classNames("bi kg-green fs-4", {
          "bi-star-fill": item <= displayValue,
          "bi-star": item > displayValue,
          "cursor-pointer": !readOnly,
        })}
        onClick={() => {
          if (readOnly || !onChange) return;
          onChange(item);
        }}
        onMouseEnter={() => {
          if (readOnly) return;
          setHovered(item);
        }}
        onMouseLeave={() => {
          if (readOnly) return;
          setHovered(null);
        }}
      />
    </span>
  ));

  return (
    <div
      className={classNames(
        "d-flex justify-content-start align-items-center gap-3",
        className
      )}
    >
      {stars}
    </div>
  );
};

export default Ratings;